// 8x8 Click-to-Dial — audited via POST /api/dial, then handed to the local
// 8x8 Work desktop app through the callto: protocol (dispatcher's extension
// rings first, then the destination). Requires 8x8 Work signed in + Web Dialer.
import React, { useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { PhoneOutgoing, Loader2 } from "lucide-react";

export async function dial8x8(phone, { targetName = "", incidentCc = "" } = {}) {
  const { data } = await client.post("/dial", { phone, target_name: targetName, incident_cc: incidentCc });
  window.location.href = `callto://${encodeURIComponent(data.phone)}`;
  return data.phone;
}

export const Dial8x8Button = ({ phone, targetName = "", incidentCc = "", compact = false }) => {
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const e164 = await dial8x8(phone, { targetName, incidentCc });
      toast.success(`Dialing ${e164} via 8x8 — answer your extension`, {
        description: "If nothing opened, make sure 8x8 Work is running and signed in.",
      });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start 8x8 call");
    }
    setBusy(false);
  };
  return (
    <button
      data-testid={`dial8x8-${(phone || "").replace(/[^\d]/g, "")}`}
      onClick={go}
      title="Place call through your 8x8 phone system (extension rings first)"
      className={`inline-flex items-center gap-1 rounded-sm font-mono font-bold uppercase transition-colors border border-[#F59E0B]/50 text-[#F59E0B] hover:bg-[#F59E0B]/15 ${compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]"}`}
    >
      {busy ? <Loader2 size={compact ? 10 : 11} className="animate-spin" /> : <PhoneOutgoing size={compact ? 10 : 11} />} 8x8
    </button>
  );
};
